import { ExportAsConfig, ExportAsService } from "ngx-export-as";
import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { NgxPrinterService } from "ngx-printer";

@Component({
  selector: "app-preview-invoice",
  templateUrl: "./preview-invoice.component.html",
  styleUrls: ["./preview-invoice.component.scss"],
})
export class PreviewInvoiceComponent implements OnInit {
  invoice: any;
  exportAsConfig: ExportAsConfig = {
    type: "pdf", // the type you want to download
    elementIdOrContent: "print-section",
    options: {
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    },
    // the id of html/table element
  };

  constructor(
    private router: Router,
    private exportService: ExportAsService,
    private printerService: NgxPrinterService
  ) {
    this.invoice = this.router.getCurrentNavigation().extras.state.invoice;
  }

  printerMarkerClicked() {
    this.printerService.printDiv("print-section");
  }

  export() {
    this.exportService
      .save(this.exportAsConfig, "INVOICE")
      .subscribe((content) => {
      });
  }

  ngOnInit(): void {}
}
